import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1421.14123,2.41732472 L1512.916,66.6794857 L215.481342,1918.96202 L216.076,1919.37849 L215.698175,1919.91862 L123.327514,1855.23998 L246.074,1679.99949 L0,1680 L0,240 L1254.726,239.999486 L1421.14123,2.41732472 Z M1500.536,280.904486 L1500.53647,678.889412 L1920,346.051765 L1920,1574.06118 L1500.53647,1241.11059 L1500.53647,1680 L520.538,1679.99949 L597.433,1570.22049 L1390.75765,1570.22118 L1390.75765,1013.98588 L1568.75294,1155.27529 L1810.22118,1346.82353 L1810.22118,573.176471 L1568.75294,764.837647 L1390.75765,906.127059 L1390.757,437.630486 L1500.536,280.904486 Z M1177.831,349.778486 L109.778824,349.778824 L109.778824,1570.22118 L322.969,1570.22049 L1177.831,349.778486 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconVideoCameraOffLine = /*#__PURE__*/function (_Component) {
  _inherits(IconVideoCameraOffLine, _Component);

  var _super = _createSuper(IconVideoCameraOffLine);

  function IconVideoCameraOffLine() {
    _classCallCheck(this, IconVideoCameraOffLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconVideoCameraOffLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconVideoCameraOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconVideoCameraOffLine.displayName = "IconVideoCameraOffLine";
  return IconVideoCameraOffLine;
}(Component);

IconVideoCameraOffLine.glyphName = 'video-camera-off';
IconVideoCameraOffLine.variant = 'Line';
IconVideoCameraOffLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconVideoCameraOffLine;
export { IconVideoCameraOffLine };